import APPCONFIG from 'constants/Config';
import {
  TOGGLE_BOXED_LAYOUT,
  TOGGLE_COLLAPSED_NAV,
  TOGGLE_NAV_BEHIND,
  TOGGLE_FIXED_HEADER,
  CHANGE_SIDEBAR_WIDTH,
  CHANGE_COLOR_OPTION,
  CHANGE_THEME,
  SEL_COMPLETA,
  SEL_TERCERO,
  GUAR_CARRO,
  SEL_SEGURO,
  SEL_TERCERO_3,
  SEL_TERCERO_2,
  SEL_TERSEGURO,
  SEL_MODO,
  TIPO_COBERTURA,
  QUOTE,
  QUOTERES,
  PDF,
  NO_COBERTURACC,
  SPINNER_PAGO,
  LIMITES,
  INTER_LISTO,
  GUAR_CARRO_DT,
  AUTO_MOTO,
  SEL_TERCERO_MOTOS,
  COLORES,
  ESTADOS,
  CIUDADES
} from '../constants/ActionTypes';

const initialSettings = APPCONFIG.settings;

const settings = (state = initialSettings, action) => {
     console.log(action)
  switch (action.type) {
    case TOGGLE_BOXED_LAYOUT:
      return {
        ...state,
        layoutBoxed: action.isLayoutBoxed
      };
    case TOGGLE_COLLAPSED_NAV:
      return {
        ...state,
        navCollapsed: action.isNavCollapsed
      };
    case TOGGLE_NAV_BEHIND:
      return {
        ...state,
        navBehind: action.isNavBehind
      };
    case TOGGLE_FIXED_HEADER:
      return {
        ...state,
        fixedHeader: action.isFixedHeader
      };
    case CHANGE_SIDEBAR_WIDTH:
      return {
        ...state,
        sidebarWidth: action.sidebarWidth
      };
    case CHANGE_COLOR_OPTION:
      return {
        ...state,
        colorOption: action.colorOption
      };
    case CHANGE_THEME:
      return {
        ...state,
        theme: action.theme
      };
     case SEL_COMPLETA:
      return {
        ...state,
        escompleta: action.escompleta
      };
      case SEL_TERCERO:
      return {
        ...state,
        dtercero: action.dtercero
      };
      case SEL_TERCERO_2:
      return {
        ...state,
        dtercero2: action.dtercero2
      };
      case SEL_TERCERO_3:
      return {
        ...state,
        dtercero3: action.dtercero3
      };
      case SEL_MODO:
      return {
        ...state,
        modo: action.modo
      };
      case SEL_TERCERO_MOTOS:
      return {
        ...state,
        dterceromotos: action.dterceromotos
      };
      case GUAR_CARRO:
      return {
        ...state,
        carro: action.carro
      };
      case SEL_SEGURO:
      return {
        ...state,
        sseguro: action.seguro
      };
        case SEL_TERSEGURO:
      return {
        ...state,
        terseguro: action.datos
      };
        case TIPO_COBERTURA:
      return {
        ...state,
        tipo_cobertura: action.tipo_cobertura
      };
        case LIMITES:
      return {
        ...state,
        limites: action.limites
      };
        case INTER_LISTO:
      return {
        ...state,
        intercom: action.intercom
      };
      case AUTO_MOTO:
      return {
        ...state,
        automoto: action.automoto
      };
      case NO_COBERTURACC:
      return {
        ...state,
        nocoberturacc: action.nocobcc
      };
      case SPINNER_PAGO:
      return {
        ...state,
        spinner: action.spinner
      };
      case QUOTE:
      return {
        ...state,
        //quote: action.quote
        quote: [...state.quote, action.quote]
      };
      case QUOTERES:
      return {
        ...state,
        //quote: action.quote
        quote: action.datas
      };
      case PDF:
      return {
        ...state,
        pdf: action.pdf
      };
      case COLORES:
      return {
        ...state,
        //quote: action.quote
        colores: action.colores
      };
      case ESTADOS:
      return {
        ...state,
        //quote: action.quote
        estados: action.estados
      };
      case CIUDADES:
        return {
          ...state,
          //quote: action.quote
          ciudades: action.ciudades
        };
      case GUAR_CARRO_DT:
      const update = state.carro;
      update.danosTerceros = action.carro;
      return {
        ...state,
        carro: update
      };     
    default:
      return state;
  };
};

module.exports = settings;



// WEBPACK FOOTER //
// ./reducers/settings.js